import { render, staticRenderFns } from "./AvatarCropper.vue?vue&type=template&id=2d1649be&scoped=true"
import script from "./AvatarCropper.vue?vue&type=script&lang=js"
export * from "./AvatarCropper.vue?vue&type=script&lang=js"
import style0 from "./AvatarCropper.vue?vue&type=style&index=0&id=2d1649be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1649be",
  null
  
)

export default component.exports